import axios from "axios";
import { toast } from "react-toastify";
import { getConnectionId } from "src/signalRService";
import { logOut } from "./redirect";
import { getDeviceFingerprint } from "./generateDeviceId";

axios.interceptors.request.use(async (x) => {
  let accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    x.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  x.headers["ConnectionId"] = `${getConnectionId()}`;
  x.headers["FingerPrintId"] = `${await getDeviceFingerprint()}`;
  return x;
}, null);

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedError) {
    toast.error("An unexpected error occurrred.");
  } else {
    switch (error.response.status) {
      case 400:
        if (error?.response?.data?.Message) {
          toast.error(error?.response?.data?.Message);
        } else {
          toast.error("درخواست نامعتبر است.");
        }
        break;
      case 401:
        toast.error("خطای احراز هویت. 401");
        logOut();
        window.location.href = "/Login";
        break;
      case 403:
        toast.error("دسترسی نامعتبر");
        break;
      case 404:
        toast.error("محتوایی یافت نشد");
        break;
      case 409:
        toast.error("خطای ارسال داده نامعتبر - 409");
        break;
      case 423:
        toast.error(error?.response?.data);
        break;
      default:
        toast.error(error.response.status);
        break;
    }
  }
  return Promise.reject(error);
});

const deafultAxios = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};

export default deafultAxios;
